import _service from '@/service'
import { getCurrencyByName } from '@/utils'
import { defineStore } from 'pinia'

export const useSystemStore = defineStore('system', {
  state: () => ({
    tabActive:0,
    tabChanged:false,
    coin:'usd',
    globalCurrency:<any>{
      rate:'1',
      symbol:'$'
    }
  }),
  getters: {
    getTabActive(state){
      return state.tabActive
    },
    getTabChanged(state){
      return state.tabChanged
    },
    getGlobalCurrency(state){
      return state.globalCurrency
    }
  },
  actions: {
    setTabActive(index:number){
      this.tabActive = index
    },
    setTabChanged(bool:boolean){
      this.tabChanged = bool
    },
    async setGlobalCurrency(){
      const currency:any = sessionStorage.getItem('currency')?.toLowerCase() || 'usd'
      let rate = '1'
      if (currency !== 'usd') {
        const {data:{tether}}:any = await _service.getRates()
        rate = tether[currency]
      }
      console.log(getCurrencyByName(currency),'-');
      
      this.globalCurrency = {...getCurrencyByName(currency),rate}
    }
  },
})
